// MUI needs a stable row id to filter; rows without a unique field get their position on the page.
export const withRowIndex = <T extends object>(rows: T[]) =>
  rows.map((row, rowIndex) => ({ ...row, rowIndex }));

export const getRowIndex = (row: { rowIndex: number }) => row.rowIndex;
